import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-[#2D1B0E] py-8" data-id="element-61">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-62">
          <p className="text-white/50 text-sm mb-3" data-id="element-63">
            © 2026 Freelance Latina · Todos los derechos reservados
          </p>
          <div className="flex items-center justify-center gap-4 text-sm" data-id="element-64">
            <button onClick={() => setActiveModal('privacy')} className="text-white/40 hover:text-white/80 transition-colors underline underline-offset-2" data-id="element-65">
              Política de Privacidad
            </button>
            <span className="text-white/20" data-id="element-66">·</span>
            <button onClick={() => setActiveModal('terms')} className="text-white/40 hover:text-white/80 transition-colors underline underline-offset-2" data-id="element-67">
              Términos y Condiciones
            </button>
          </div>
        </div>
      </footer>

      <AnimatePresence data-id="element-68">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-69">
            <motion.div initial={{
          opacity: 0,
          scale: 0.9,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.9,
          y: 20
        }} transition={{
          duration: 0.3
        }} className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto" onClick={e => e.stopPropagation()} data-id="element-70">
              {/* Header */}
              <div className="sticky top-0 bg-white border-b border-gray-100 px-6 py-4 rounded-t-2xl flex items-center justify-between" data-id="element-71">
                <h3 className="text-xl font-bold text-[#2D1B0E]" data-id="element-72">
                  {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
                </h3>
                <button onClick={() => setActiveModal(null)} className="w-8 h-8 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center transition-colors" data-id="element-73">
                  <X className="w-4 h-4 text-[#2D1B0E]" data-id="element-74" />
                </button>
              </div>

              {/* Content */}
              <div className="px-6 py-6 text-[#2D1B0E]/80 text-sm leading-relaxed space-y-4" data-id="element-75">
                {activeModal === 'privacy' ? <PrivacyContent data-id="element-76" /> : <TermsContent data-id="element-77" />}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}
function PrivacyContent() {
  return <>
      <p className="text-xs text-[#2D1B0E]/50" data-id="element-78">
        Última actualización: Febrero 2026
      </p>

      <h4 className="font-bold text-[#2D1B0E] text-base" data-id="element-79">
        1. Información que Recopilamos
      </h4>
      <p data-id="element-80">
        Al adquirir nuestro producto digital, recopilamos únicamente la
        información necesaria para procesar tu compra: nombre, dirección de
        correo electrónico y datos de pago procesados de forma segura a través
        de Gumroad.
      </p>

      <h4 className="font-bold text-[#2D1B0E] text-base" data-id="element-81">
        2. Uso de la Información
      </h4>
      <p data-id="element-82">
        Tu información se utiliza exclusivamente para: entregar el producto
        digital adquirido, enviar actualizaciones relacionadas con tu compra y
        mejorar nuestros servicios. No vendemos, alquilamos ni compartimos tu
        información personal con terceros.
      </p>

      <h4 className="font-bold text-[#2D1B0E] text-base" data-id="element-83">
        3. Protección de Datos
      </h4>
      <p data-id="element-84">
        Implementamos medidas de seguridad estándar de la industria para
        proteger tu información personal. Los pagos son procesados de forma
        segura por Gumroad, y no almacenamos datos de tarjetas de crédito en
        nuestros servidores.
      </p>

      <h4 className="font-bold text-[#2D1B0E] text-base" data-id="element-85">4. Cookies</h4>
      <p data-id="element-86">
        Nuestro sitio puede utilizar cookies para mejorar tu experiencia de
        navegación y analizar el tráfico del sitio. Puedes configurar tu
        navegador para rechazar cookies en cualquier momento.
      </p>

      <h4 className="font-bold text-[#2D1B0E] text-base" data-id="element-87">5. Tus Derechos</h4>
      <p data-id="element-88">
        Tienes derecho a acceder, corregir o eliminar tu información personal en
        cualquier momento. Para ejercer estos derechos, puedes contactarnos
        directamente.
      </p>

      <h4 className="font-bold text-[#2D1B0E] text-base" data-id="element-89">
        6. Cambios a Esta Política
      </h4>
      <p data-id="element-90">
        Nos reservamos el derecho de actualizar esta política de privacidad en
        cualquier momento. Los cambios serán publicados en esta página con la
        fecha de actualización correspondiente.
      </p>
    </>;
}
function TermsContent() {
  return <>
      <p className="text-xs text-[#2D1B0E]/50" data-id="element-91">
        Última actualización: Febrero 2026
      </p>

      <h4 className="font-bold text-[#2D1B0E] text-base" data-id="element-92">
        1. Producto Digital
      </h4>
      <p data-id="element-93">
        Freelance Latina es un producto digital (eBook en formato PDF) que
        incluye templates, prompts y recursos descargables. Al completar tu
        compra, recibirás acceso inmediato al contenido digital.
      </p>

      <h4 className="font-bold text-[#2D1B0E] text-base" data-id="element-94">2. Uso Permitido</h4>
      <p data-id="element-95">
        El contenido adquirido es para uso personal y profesional del comprador.
        No está permitido redistribuir, revender, compartir públicamente o
        reproducir el contenido sin autorización escrita previa.
      </p>

      <h4 className="font-bold text-[#2D1B0E] text-base" data-id="element-96">3. Resultados</h4>
      <p data-id="element-97">
        Los resultados mencionados en nuestro material de marketing son ejemplos
        y no constituyen una garantía de ingresos. Los resultados individuales
        pueden variar según el esfuerzo, dedicación y circunstancias de cada
        persona.
      </p>

      <h4 className="font-bold text-[#2D1B0E] text-base" data-id="element-98">
        4. Política de Reembolso
      </h4>
      <p data-id="element-99">
        Debido a la naturaleza digital del producto y su entrega inmediata,
        todas las ventas son finales. Si experimentas problemas técnicos con la
        descarga, te ayudaremos a resolverlos.
      </p>

      <h4 className="font-bold text-[#2D1B0E] text-base" data-id="element-100">
        5. Propiedad Intelectual
      </h4>
      <p data-id="element-101">
        Todo el contenido, incluyendo textos, diseños, templates y prompts, es
        propiedad de Freelance Latina y está protegido por las leyes de derechos
        de autor aplicables.
      </p>

      <h4 className="font-bold text-[#2D1B0E] text-base" data-id="element-102">
        6. Limitación de Responsabilidad
      </h4>
      <p data-id="element-103">
        Freelance Latina proporciona información educativa y herramientas. No
        somos responsables por decisiones financieras, fiscales o de negocio
        tomadas basándose en nuestro contenido. Recomendamos consultar con
        profesionales calificados para asesoría específica.
      </p>

      <h4 className="font-bold text-[#2D1B0E] text-base" data-id="element-104">7. Ley Aplicable</h4>
      <p data-id="element-105">
        Estos términos se rigen por las leyes de los Estados Unidos de América.
        Cualquier disputa será resuelta en los tribunales competentes.
      </p>
    </>;
}